// frontend/src/services/api.js
import axios from 'axios';
import Swal from 'sweetalert2';

const api = axios.create({
  baseURL: 'https://ssk3ita.backend.kruwirat.com/api',
  // baseURL: 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// ตรวจสอบและเพิ่ม token ในทุกคำขอ
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// จัดการกับข้อผิดพลาดที่เกิดขึ้นจากการตอบกลับของ API
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    
    // จัดการกับข้อผิดพลาดต่างๆ
    if (error.response) {
      // กรณี token หมดอายุหรือไม่ถูกต้อง
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        Swal.fire({
          icon: 'error',
          title: 'เซสชันหมดอายุ',
          text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
          confirmButtonText: 'ตกลง'
        }).then(() => {
          window.location.href = '/login';
        });
      }
      
      // กรณีไม่มีสิทธิ์เข้าถึง
      else if (error.response.status === 403) {
        Swal.fire({
          icon: 'error',
          title: 'ไม่มีสิทธิ์เข้าถึง',
          text: 'คุณไม่มีสิทธิ์เข้าถึงข้อมูลหรือฟังก์ชันนี้',
          confirmButtonText: 'ตกลง'
        });
      }
    } else if (error.request) {
      // กรณีไม่ได้รับการตอบกลับจากเซิร์ฟเวอร์
      Swal.fire({
        icon: 'error',
        title: 'การเชื่อมต่อล้มเหลว',
        text: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่อของคุณ',
        confirmButtonText: 'ตกลง'
      });
    }
    
    return Promise.reject(error);
  }
);

// ฟังก์ชันเปิด/ปิดการแสดงผลคะแนน
export const toggleShowScores = async (settingsId, showScores) => {
  try {
    const response = await api.put(`/system-settings/${settingsId}/toggle-show-scores`, { show_scores: showScores });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
  }
};

// ฟังก์ชันตรวจสอบสถานะการแสดงผลคะแนน
export const checkShowScores = async (fiscalYearId) => {
  try {
    const response = await api.get(`/system-settings/show-scores/${fiscalYearId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
  }
};

export default api;